export default "__VITE_ASSET__CaU82QG$__"